import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import NewModal from '../Modal/NewModal';
import { useContent } from '../../../content/content-provider';

const styles = makeStyles(({ spacing }) => ({
  modal: {
    borderRadius: '16px',
  },
  modalContent: {
    padding: `${spacing(6)}px ${spacing(6)}px ${spacing(6)}px ${spacing(6)}px`,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },
  title: {
    marginBottom: spacing(4),
  },
}));

const NewLoadingSpinner = () => {
  const classes = styles();

  const [content] = useContent();

  return (
    <NewModal
      open
      dataTestId="loadingSpinner"
      showHeader={false}
      PaperProps={{ className: classes.modal }}
    >
      <div className={`${classes.modalContent} ${classes.container}`}>
        <Typography variant="h2" component="h1" className={classes.title}>
          {content.spinner}
        </Typography>
        <CircularProgress />
      </div>
    </NewModal>
  );
};

export default NewLoadingSpinner;
